import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private http = inject(HttpClient);

  getUnansweredMessages() {
    return this.http.get<any>(environment.apiUrl + 'unanswered-messages');
  }

  getUserMessages(numberId: number, providerCodeId: number) {
    return this.http.get<any>(
      environment.apiUrl + 'user-messages/' + numberId + '/' + providerCodeId,
    );
  }

  sendMessage(numberId: number, providerCodeId: number, message: string, mine = true) {
    return this.http.post<any>(environment.apiUrl + 'send-message', {
      number_id: numberId,
      provider_code_id: providerCodeId,
      message,
      mine,
    });
  }

  sendMessageAsClient(
    phoneNumber: string,
    identity: string,
    providerCodeId: number,
    providerNumber: number,
    message: string,
  ) {
    return this.http.post<any>(environment.apiUrl + 'send-message-as-client', {
      phone_number: phoneNumber,
      identity,
      provider_code_id: providerCodeId,
      provider_number: providerNumber,
      message,
    });
  }

  getMonthlyStats() {
    return this.http.get<any>(environment.apiUrl + 'monthly-stats');
  }

  getDailyStats() {
    return this.http.get<any>(environment.apiUrl + 'daily-stats');
  }
}
